// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2bKrO","tab":"Tabs_tab__2IUQA","tabActive":"Tabs_tabActive__3Yzh8"};